module.exports = __webpack_public_path__ + "img/cloud_backup_up_arrow_b.541b51d5.svg";